/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HumanCapitalCompanyIncludeFilterItems } from './humanCapitalCompanyIncludeFilterItems';
import { HumanCapitalCompanyScopeFilter } from './humanCapitalCompanyScopeFilter';


export interface HumanCapitalCompanyIncludeFilterInner { 
    relation?: HumanCapitalCompanyIncludeFilterInner.RelationEnum;
    scope?: HumanCapitalCompanyScopeFilter;
}
export namespace HumanCapitalCompanyIncludeFilterInner {
    export type RelationEnum = 'humanCapitalManager' | 'humanCapitalDirector' | 'company' | 'payrollManager' | 'generalManager' | 'compensationManager' | 'payrollStaff' | 'humanCapitalStaff' | 'humanCapitalStaff2';
    export const RelationEnum = {
        HumanCapitalManager: 'humanCapitalManager' as RelationEnum,
        HumanCapitalDirector: 'humanCapitalDirector' as RelationEnum,
        Company: 'company' as RelationEnum,
        PayrollManager: 'payrollManager' as RelationEnum,
        GeneralManager: 'generalManager' as RelationEnum,
        CompensationManager: 'compensationManager' as RelationEnum,
        PayrollStaff: 'payrollStaff' as RelationEnum,
        HumanCapitalStaff: 'humanCapitalStaff' as RelationEnum,
        HumanCapitalStaff2: 'humanCapitalStaff2' as RelationEnum
    };
}


